import Turbolinks from "turbolinks";
import Rails from "@rails/ujs";
import ReactOnRails from 'react-on-rails';
import * as ActiveStorage from "@rails/activestorage";
global.$ = require('jquery');

Rails.start();
Turbolinks.start();
ActiveStorage.start();

// Imports externes
import "bootstrap";

// Imports internes
import { initConnection } from"../components/initConnection";
import "../components/navbar";

document.addEventListener('turbolinks:load', () => {
    initConnection;
});


// Internal Import
import HelloWorld from '../bundles/HelloWorld/components/HelloWorld';
import HomePage from '../bundles/HomePage/components/HomePage';
import AuthContainer from '../bundles/Devise/components/AuthContainer';

// Import des composants Cooptation
import SponsorshipForm from '../bundles/Cooptation/components/SponsorshipForm';
import SupportButton from '../bundles/Cooptation/components/SupportButton';
import EligibleSupportersList from '../bundles/Cooptation/components/EligibleSupportersList';
import FilleulSignupForm from '../bundles/Cooptation/components/FilleulSignupForm';
import PaymentForm from '../bundles/Cooptation/components/PaymentForm';
import MySponsorshipsTable from '../bundles/Cooptation/components/MySponsorshipsTable';

// Import des pages Cooptation
import NewSponsorshipPage from '../bundles/Cooptation/pages/NewSponsorshipPage';
import SponsorshipShowPage from '../bundles/Cooptation/pages/SponsorshipShowPage';
import MySponsorshipsPage from '../bundles/Cooptation/pages/MySponsorshipsPage';
import AdminDashboard from '../bundles/Cooptation/pages/AdminDashboard';
import AdminPage from '../bundles/Cooptation/pages/AdminPage';

// Import des composants Events
import EventsList from '../components/EventsList';
import EventDetail from '../components/EventDetail';
import EventForm from '../components/EventForm';
import EventRegistration from '../components/EventRegistration';
import OrganizerDashboard from '../components/OrganizerDashboard';
import EventOrganizers from '../components/EventOrganizers';
import EventAccessRules from '../components/EventAccessRules';
import EventDashboard from '../components/EventDashboard';
import EventCommunication from '../components/EventCommunication';
import MagicRegistration from '../components/MagicRegistration';
import EventPublicRegister from '../components/EventPublicRegister';
import EventPaymentPage from '../components/EventPaymentPage';
import OptionsPage from '../components/OptionsPage';
import AdminDashboardPage from '../components/AdminDashboardPage';
import AdminSponsorshipsPage from '../components/AdminSponsorshipsPage';
import ProfilePage from '../components/ProfilePage';
import LegalTextPage from '../components/LegalTextPage';


// Register components with ReactOnRails
ReactOnRails.register({
    HelloWorld,
    HomePage,
    AuthContainer,
    // Composants Cooptation
    SponsorshipForm,
    SupportButton,
    EligibleSupportersList,
    FilleulSignupForm,
    PaymentForm,
    MySponsorshipsTable,
    // Pages Cooptation
    NewSponsorshipPage,
    SponsorshipShowPage,
    MySponsorshipsPage,
    AdminDashboard,
    AdminPage,
    // Composants Events
    EventsList,
    EventDetail,
    EventForm,
    EventRegistration,
    OrganizerDashboard,
    EventOrganizers,
    EventAccessRules,
    EventDashboard,
    EventCommunication,
    MagicRegistration,
    EventPublicRegister,
    EventPaymentPage,
    OptionsPage,
    AdminDashboardPage,
    AdminSponsorshipsPage,
    ProfilePage,
    LegalTextPage,
});
